import { Outlet } from 'react-router-dom'
import Footer from './../Footer/Footer'
import './index.scss'
import ThemeToggle from '../ThemeToggle/ThemeToggle.jsx'
import Navbar from './../Navbar/index.jsx'

const Layout = () => {
  return (
    <div className="App">
      <Navbar />
      <div className="page">
        <span className="tags top-tags">&lt;body&gt;</span>
        <Outlet />
        <span className="tags bottom-tags">
          &lt;body&gt;
          <br />
          <span className="bottom-tag-html">&lt;/html&gt;</span>
        </span>
      </div>
      <Footer />
      <ThemeToggle />
    </div>
  )
}

export default Layout
